var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('main',{staticClass:"power-rankings"},[_c('router-view')],1),(_vm.showFooter)?_c('PowerRankingsFooter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }